import { ContractType, InvestorBidStatus, PricingType, UnitDecimals } from '~/constants';
import { formatDollars, formatNumber } from '~/utils/formatNumber';
import { display } from '../../common';
import { Project } from '~/types/project';
import { getProjectStorageSizeKwh } from '~/utils/calculators/system';

//TODO typing
export const getCostData = (projectCosts: any, projectBid: any) => {
  //projectCosts can be an array for sell side fees
  if (Array.isArray(projectCosts) && projectCosts.length > 0) {
    //match individual projectCost object to the current bid
    const projectCost = projectCosts?.find((row: any) => row?.bid?.id === projectBid?.id);
    return projectCost;
  } else {
    //return object if not an array
    return projectCosts;
  }
};

export const getInvestorBidAmount = (project: any, projectBid: any, projectCosts: any) => {
  const cost = getCostData(projectCosts, projectBid);
  const isStorageOnly = project?.storage && project?.storage.length > 0 && project?.projectArrays?.length === 0;
  const storageSizeKwh = isStorageOnly ? getProjectStorageSizeKwh(project) : 0;

  if (projectBid) {
    // Handle non-ITC projects
    const decimals = project.pricingType === PricingType.OFFTAKE && project?.contractType === ContractType.PPA ? 4 : 0;
    const overallAmount = project.pricingType === PricingType.OFFTAKE
      ? cost?.bid?.amount
      : cost?.overall?.investorBidAmount;


    let investorBidAmount = formatDollars(overallAmount, { dec: decimals });
    if (project?.pricingType === PricingType.OFFTAKE) {
      const isLeaseOrESA = project.contractType === ContractType.LEASE || project.contractType === ContractType.ENERGY_SERVICE_AGREEMENT;
      investorBidAmount += isLeaseOrESA ? ' / year' : ' / kWh';
    }

    // Handle ITC projects
    if (project?.pricingType === PricingType.ITC) {
      investorBidAmount = `${formatDollars(cost?.itc?.percentOfBid)}`;
    }

    // Tack on $ per Wdc for EPC + Dev fee projects, % of ITC for ITC projects
    let investorBidAmountUnit: string = '';
    if ((project?.pricingType === PricingType.ACQUISITION || project?.pricingType === PricingType.DEV_FEE) && overallAmount) {
      const dollarsPerWdc = cost?.perWdc?.investorBidAmount;
      investorBidAmountUnit = `${formatDollars(dollarsPerWdc, { dec: UnitDecimals.WDC })} / Wdc`;
    }
    if (project?.pricingType === PricingType.ITC) {
      investorBidAmountUnit = `${formatNumber(cost?.itc?.investorBidAmount, UnitDecimals.TOTAL)}% of ITC value`;
    }

    if (isStorageOnly && overallAmount) {
      const dollarsPerKwh = storageSizeKwh ? overallAmount / storageSizeKwh : 0;
      investorBidAmountUnit = `${formatDollars(dollarsPerKwh, { dec: 2 })} / kWh`;
    }

    return {
      investorBidAmount,
      investorBidAmountUnit
    };
  }
  return display(undefined);
};

//TODO typing
export const getFeeAmount = (project: Project, projectBid: any, projectCosts: any) => {
  const cost = getCostData(projectCosts, projectBid);
  const sellerFees = cost?.bid?.sellerFees;

  if (sellerFees) {
    const { sellerFee, sellerStorageFee } = sellerFees;
    const hasSellerFee = sellerFee != null || sellerStorageFee != null;

    if (projectBid) {
      if (project?.pricingType === PricingType.ITC) {
        return hasSellerFee ? `${formatDollars(cost?.itc?.feesTotal)}` : '$0.00';
      }
      return hasSellerFee ? `${formatDollars(cost?.overall?.feesTotal)}` : '$0.00';
    }
  }

  return 'Awaiting bid...';
};

export const getOtherBudgetItemsAmount = (projectBid: any, projectCosts: any) => {
  const cost = getCostData(projectCosts, projectBid);
  const otherBudgetItems = `${formatDollars(cost?.overall?.otherBudgetItemsTotal, { dec: UnitDecimals.TOTAL })}`;
  const hasOtherBudgetItems = cost?.overall?.otherBudgetItemsTotal !== 0;
  return {
    otherBudgetItems,
    hasOtherBudgetItems
  };
};


export const getNetProceeds = (project: Project, projectBid: any, projectCosts: any) => {
  const cost = getCostData(projectCosts, projectBid);

  let netProceeds: string = '';
  if (projectBid?.bidStatus === InvestorBidStatus.ACCEPTED || projectBid?.bidStatus === InvestorBidStatus.PENDING) {

    if (project?.pricingType === PricingType.ITC) {
      netProceeds = `${formatDollars(cost?.itc?.total)}`;
    }
    else {
      netProceeds = `${formatDollars(cost?.overall?.total)}`;
    }

    const netProceedsUnit = `${formatDollars(cost?.perWdc?.total, { dec: UnitDecimals.WDC })} / Wdc`;

    return {
      netProceeds,
      netProceedsUnit,
    };

  } else {
    return display(undefined);
  }
};
